<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>
          
          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="editedItem.AREANAME" :label="$t('eventarea_col1')"></v-text-field>
              </v-row>
              <v-row dense> 
                <v-textarea hide-details counter="500" v-model="editedItem.AREADESC" :label="$t('eventarea_label1')" value="" outlined :rules="[ v => (v.length <= 500) || this.$t('eventarea_label2') ]" ></v-textarea>
              </v-row>

              <v-row dense no-gutters align="center" justify="start">
                <v-checkbox :label="$t('eventarea_col4')" v-model="editdirect" hide-details />
              </v-row>


              <v-row dense no-gutters align="center" justify="start" class="mt-2">
                <v-col cols="9">
                  <v-text-field 
                    outlined height="43" dense ref="addr1" single-line hide-details
                    v-model="editedItem.ADDR1" :disabled="editdirect ? false : true" :label="$t('eventarea_col2')"/>
                </v-col>
                <v-col cols="2">
                  <v-btn class="search_btn ml-2" elevation="0" outlined large @click="postcode">{{$t('eventarea_label3')}}</v-btn>
                </v-col>
              </v-row>
              <v-row dense no-gutters align="center" justify="start" class="mt-2">
                <v-col cols="9">
                  <v-text-field
                    outlined height="43" dense single-line hide-details
                    v-model="editedItem.ADDR1ENG" :disabled="editdirect ? false : true" :label="$t('eventarea_col8')"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field hide-details outlined counter="100" ref="addr2" v-model="editedItem.ADDR2" :label="$t('eventarea_label4')" :rules="[ v => (v.length <= 100) || this.$t('eventarea_label5') ]"></v-text-field>
                </v-col>
              </v-row>

              <v-row v-if="editdirect">
                <v-col cols="6">
                  <v-text-field hide-details outlined v-model="editedItem.LATITUTE" :label="$t('eventarea_col5')"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field hide-details outlined v-model="editedItem.LONGITUTE" :label="$t('eventarea_col6')"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="editdirect" justify="center">
                <v-btn class="dialog_btn" rounded large  @click="checkmap">{{$t("eventarea_col7")}}</v-btn>
              </v-row>

              <v-row>
                <div id="map" style="width:300px;height:300px;margin-top:10px;display:none"></div>
              </v-row>
              <v-row dense class="mt-5">
                <v-col>
                  <v-row justify="center">

                    <div id="gmap" />

                  </v-row>
                </v-col>
              </v-row>              
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" justify="start" dense>
      <v-col cols="12" md="3" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0" align="center">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>        
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
    </v-row>
  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.AREANAME>
          <a :class="sort_name=='AREANAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('AREANAME')">{{$t("eventarea_col1")}}</a>
        </template>
        <template v-slot:header.ADDR1>
          <a :class="sort_name=='ADDR1'?'cheader_sortselect':'cheader_sort'" @click="customsort('ADDR1')">{{$t("eventarea_col2")}}</a>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eventarea_col3")}}</label>
        </template>

        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  </v-container>
</template>


<script type="text/javascript" src="//dapi.kakao.com/v2/maps/sdk.js?appkey=82fc565ca4c226a9f8b7d9f0b9253275&libraries=services"></script>

<script>

//import dateFormat from 'dateformat'
export default {
    data:()=>({

      //필수 페이징 파라메터
      loading : false,    //로딩 표시
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수

      gmap:null,
      gmarker:null,

      editdirect:false,

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          AREANAME:'',
          AREADESC:'',
          LATITUTE:'37.51205332712675',
          LONGITUTE:'127.05914127516714',
          ADDR1:'',
          ADDR1ENG:'',
          ADDR2:'',
      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '장소명', value: 'AREANAME', sortable: true, align:'left' },
        {text: '주소', value: 'ADDR1', sortable: true, align:'left'},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],

      //검색 파라메터
      sort_name: 'AREANAME',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

      marker_position:{lat: 37.512268, lng: 127.058940},
      map_position: {lat: 37.512268, lng: 127.058940},
      
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,
      
    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      checkmap(){
        //지도 위치 확인
        this.map_position    = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
        this.marker_position = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');

        //맵은 화면에 div가 노출된 후에 그려야한다. 안보이면 오류남.
        if(this.gmap == null){
          setTimeout(() => {
            this.gmap = new google.maps.Map(document.getElementById('gmap'), {
              zoom: 16, center:this.map_position
            });
            this.gmarker = new google.maps.Marker({position:this.marker_position});
            this.gmarker.setMap(this.gmap);
          }, 300)
        }else{
          this.gmap.panTo(this.map_position);
          this.gmarker.setPosition(this.marker_position);
        }

      },

      postcodetoMap(mpos){
        this.map_position    = mpos;
        this.marker_position = mpos;

        this.gmap.panTo(this.map_position);
        this.gmarker.setPosition(this.marker_position);

        //지도위치 저장
        var temp = JSON.stringify(this.marker_position);
        const pos = JSON.parse(temp);
        this.editedItem.LATITUTE  =  String(pos.lat);
        this.editedItem.LONGITUTE =  String(pos.lng);
      },
      
      postcodetoAddr(addr, addreng){
        console.log(`addr : ${addr} / addreng : ${addreng}`);
        this.editedItem.ADDR1 = addr;
        this.editedItem.ADDR1ENG = addreng;
      },

      //지도
      postcode(){

        //콜백에서 못찾아서 콘스트로 미리 빼둔다.
        const callback_mapfunction      = this.postcodetoMap;
        const callback_addrfunction     = this.postcodetoAddr;

        new daum.Postcode({
            oncomplete: function(data) {

                
                var addr = data.address; // 최종 주소 변수
                var addreng = data.addressEnglish;
                if(data.userSelectedType == "J"){
                  //지번
                  addr = data.jibunAddress; 
                  addreng = data.jibunAddressEnglish;
                }

                //주소 정보를 해당 필드에 넣는다.
                callback_addrfunction(addr, addreng);
                
                var geocoder = new daum.maps.services.Geocoder();
                
                //주소로 상세 정보를 검색
                geocoder.addressSearch(data.address, function(results, status) {

                    // 정상적으로 검색이 완료됐으면
                    if (status === window.daum.maps.services.Status.OK) {

                        var result = results[0]; //첫번째 결과의 값을 활용

                        // 해당 주소에 대한 좌표를 받아서
                        //var coords = new daum.maps.LatLng(result.y, result.x);
                        var markerpos = JSON.parse('{"lat":'+result.y+', "lng":'+result.x+'}');
                        callback_mapfunction(markerpos);

                        //지도를 보여준다.
                        /*
                        mapContainer.style.display = "block";
                        map.relayout();
                        // 지도 중심을 변경한다.
                        map.setCenter(coords);
                        // 마커를 결과값으로 받은 위치로 옮긴다.
                        marker.setPosition(coords)
                        */

                    }
                });
            }
        }).open();

      },

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },


      loadpage(p){
        
          if(this.loading){
            return;
          }
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/StepAreaList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.AREANAME  == undefined || this.editedItem.AREANAME.length < 1){
          this.$alert(this.$t('eventarea_msg1'));
          return;
        } 
        if(this.editedItem.ADDR1  == undefined || this.editedItem.ADDR1.length < 1){
          this.$alert(this.$t('eventarea_msg2'));
          return;
        } 
        if(this.editedItem.ADDR2  == undefined || this.editedItem.ADDR2.length < 1){
          this.$alert(this.$t('eventarea_msg3'));
          return;
        } 

        if(this.editedItem.LATITUTE  == undefined || this.editedItem.LATITUTE.length < 1){
          this.$alert(this.$t('eventarea_msg4'));
          return;
        } 
        if(this.editedItem.LONGITUTE  == undefined || this.editedItem.LONGITUTE.length < 1){
          this.$alert(this.$t('eventarea_msg5'));
          return;
        } 


        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/StepAreaUpdate',{
                AREANAME: escape(this.editedItem.AREANAME)
              , AREADESC: this.editedItem.AREADESC == null || this.editedItem.AREADESC == undefined ? '' : escape(this.editedItem.AREADESC)
              , ADDR1: escape( this.editedItem.ADDR1)
              , ADDR1ENG: this.editedItem.ADDR1ENG == null || this.editedItem.ADDR1ENG == undefined ? '' : escape(this.editedItem.ADDR1ENG)
              , ADDR2: escape(this.editedItem.ADDR2)
              , LATITUTE:   this.editedItem.LATITUTE
              , LONGITUTE:  this.editedItem.LONGITUTE
              , IDX: this.editedItem.IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/StepAreaInsert',{
                AREANAME: escape(this.editedItem.AREANAME)
              , AREADESC: this.editedItem.AREADESC == null || this.editedItem.AREADESC == undefined ? '' : escape(this.editedItem.AREADESC)
              , ADDR1: escape( this.editedItem.ADDR1)
              , ADDR1ENG: this.editedItem.ADDR1ENG == null || this.editedItem.ADDR1ENG == undefined ? '' : escape(this.editedItem.ADDR1ENG)
              , ADDR2: escape(this.editedItem.ADDR2)
              , LATITUTE:   this.editedItem.LATITUTE
              , LONGITUTE:  this.editedItem.LONGITUTE
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      
      //신규 추가
      newinsert(){

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)

        this.editedItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.editedItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

        this.dialog = true;

        //맵은 화면에 div가 노출된 후에 그려야한다. 안보이면 오류남.
        if(this.gmap == null){
          setTimeout(() => {
            this.gmap = new google.maps.Map(document.getElementById('gmap'), {
              zoom: 16, center:this.map_position
            });
            this.gmarker = new google.maps.Marker({position:this.marker_position});
            this.gmarker.setMap(this.gmap);
          }, 300)
        }else{
          this.gmap.panTo(this.map_position);
          this.gmarker.setPosition(this.marker_position);
        }

      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.map_position    = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
        this.marker_position = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
        this.dialog = true;

        //맵은 화면에 div가 노출된 후에 그려야한다. 안보이면 오류남.
        if(this.gmap == null){
          setTimeout(() => {
            this.gmap = new google.maps.Map(document.getElementById('gmap'), {
              zoom: 16, center:this.map_position
            });
            this.gmarker = new google.maps.Marker({position:this.marker_position});
            this.gmarker.setMap(this.gmap);
          }, 300)
        }else{
          this.gmap.panTo(this.map_position);
          this.gmarker.setPosition(this.marker_position);
        }

      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/StepAreaDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage(1);
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          

      },

      //국가선택 콜백
      nationcallback(var1){
        if(var1.NAMEKOR.length > 0){
          this.editedItem.NATION  = var1.NACODE;
          this.editedItem.NAMEKOR = var1.NAMEKOR;
        }
      },


    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

  #gmap{
    width:500px;
    height: 300px;
    background-color: gray;
  }


</style>